<template>
  <div class="main-content-container overflow-hidden">
    <ProductsGrid />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import ProductsGrid from "@/components/Pages/Management/Catalog/ListCatalog.vue";

export default defineComponent({
  name: "ProductsGridPage",
  components: {
    ProductsGrid,
  },
});
</script>
